// Classes
import { ListMembershipReducerState } from "Containers/Filter/ListMembership/classes/listMembership.classes";
import { AttributeObject } from "../classes/attributes.classes";

/**
 * @function getListMembershipAttributes
 *
 * Post-processes the attributes for this section of the filter,
 * so that they can just be stringified on the fly and sent to
 * the back end for safe keeping.  This pre-processing allows
 * us to rebuild the Pill attributes effectively and quickly.
 * Meant to be passed into a greater array consisting of all
 * attributes before being sent to the back-end API like so.
 *
 * [visitorTypeAttributes, geographyAttributes...]
 *
 * @param {ListMembershipReducerState} listMembership - The current state
 * of the listMembership filter section.
 * @return {AttributeObject | undefined}
 *
 * @example
 *
 *     getListMembershipAttributes(listMembership)
 */
export const getListMembershipAttributes = (
  listMembership: ListMembershipReducerState
) => {
  let attributeArray: any[] = [];

  listMembership.lists.map(list => {
    attributeArray.push(`${list.label}`);
  });

  let attributeObject: any;

  if (attributeArray.length > 0) {
    attributeObject = new AttributeObject(
      `Lists=${attributeArray.length}`,
      "listMembership",
      attributeArray
    );
  } else {
    attributeObject = undefined;
  }

  return attributeObject;
};
try {
    // @ts-ignore
    getListMembershipAttributes.displayName = "getListMembershipAttributes";
    // @ts-ignore
    getListMembershipAttributes.__docgenInfo = { "description": "", "displayName": "getListMembershipAttributes", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Attributes/utilities/getListMembershipAttributes.ts#getListMembershipAttributes"] = { docgenInfo: getListMembershipAttributes.__docgenInfo, name: "getListMembershipAttributes", path: "src/shared/containers/Attributes/utilities/getListMembershipAttributes.ts#getListMembershipAttributes" };
}
catch (__react_docgen_typescript_loader_error) { }